import * as actionType from "../actions/actionTypes"

export const userSettingPop = setSateValule => {
  return {
    type: actionType.USER_SETTING_POPUP,
    payload: setSateValule,
  }
}

export const userNotificationsPop = setSateValule => {
  return {
    type: actionType.USER_NOTIFICATIONS_POPUP,
    payload: setSateValule,
  }
}

export const menuMobile = menuclasses => {
  return {
    type: actionType.MENU_MOBILE,
    payload: menuclasses,
  }
}

export const searchClassesToggle = srcClasses => {
  return {
    type: actionType.SEARCH_CLASSES,
    payload: srcClasses,
  }
}
